const appStateProvider = () => {
  const state = {
    getUnityOrgId: () => {
      return localStorage.getItem("UnityOrgId");
    },
    getOrgName: () => {
      return localStorage.getItem("ChurchName");
    },
    getIsUnity: () => localStorage.getItem("IsUnity"),
    getActiveEnvironment: () => localStorage.getItem("environment"),
    getModulesData: () => {
      const data = localStorage.getItem("ModulesData");
      if (!data) return [];
      return JSON.parse(data);
    },
    // TODO: inject as environment variable
    getAppModules: () => [
      { name: "Mobile App", id: "Mobile App" },
      { name: "App Builder", id: "App Builder" }
    ],
    getUnityAppModule: () => { return window.UNITY_MODULE_ID; },
    getAuthToken: () => {
      return localStorage.getItem("AuthToken");
    },
    getSessionId: () => {
      return localStorage.getItem("SessionId");
    },
    getAnalyticsToken: () => {
      const isUnity = state.getIsUnity() === 'true';
      return {
        token: isUnity ? state.getSessionId() : state.getAuthToken(),
        isUnity: isUnity
      }
    },
    isStandalone: () => {
      const appModules = state.getAppModules();
      const isUnity = state.getIsUnity();
      const nonDarkModules = state.getModulesData().filter(m => !m.is_dark_provisioned) || [];
      const appModuleExists = nonDarkModules
        .map((m) => m.name)
        .filter((m) => appModules.map((a) => a.name).includes(m));
      return nonDarkModules.length === 1 && appModuleExists && isUnity;
    },
  };

  return state;
};

export default appStateProvider;
